var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Positive",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297.64 141.73",
    style: {
      enableBackground: "new 0 0 297.64 141.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#131E29;}\n\t.st1{fill:#FF4713;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Small_Scale_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.83,63.84h-2.62h-2.62L7.09,92h5.82l1.92-5.63h5.38h5.38L27.5,92h5.82L22.83,63.84z M20.21,81.6h-3.77 l3.75-11.05h0.02h0.02l3.75,11.05H20.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.31,63.84h-2.62h-2.62L64.57,92h5.82l1.92-5.63h5.38h5.38L84.98,92h5.82L80.31,63.84z M77.69,81.6h-3.77 l3.75-11.05h0.02h0.02l3.75,11.05H77.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.66,63.84V92h-5.71l-12.38-18.65h-0.08V92h-5.55V63.84h5.55l12.52,19.02h0.08V63.84H122.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.32,68.83h-7.76v-4.99h21.11v4.99h-7.8V92h-5.55V68.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.16,63.84h5.61V92h-5.61V63.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.51,92h4.86l10.5-28.15h-6.04l-6.86,20.22h0h-0.05h0l-6.86-20.22h-6.04L46.51,92h4.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.35,130.16l0.9-2.42c1.82,2.44,4.83,4.53,8.91,4.53c3.85,0,6.7-1.99,6.7-5.11 c0-3.91-3.15-4.88-7.08-6.41c-3.93-1.53-8.32-3.08-8.32-7.74c0-4.04,3.66-7.1,8.34-7.1c2.9,0,5.96,1.08,8.57,3.13l-0.86,2.3 c-2.19-1.93-5-3.24-7.74-3.24c-2.94,0-5.88,1.63-5.9,4.78c-0.02,3.39,3.08,4.31,6.68,5.75c4.62,1.84,8.69,3.12,8.69,8.3 c0,4.62-4.04,7.53-9.08,7.53C247.68,134.46,244.08,133.14,241.35,130.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.22,108.54h-8.81v-2.13h19.97v2.13h-8.94l0,25.44h-2.22L276.22,108.54z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.65,126.73h-13.18l-2.7,7.24h-2.38l10.28-27.57h2.78l10.28,27.57h-2.38L229.65,126.73z M228.86,124.6 l-5.78-15.48h-0.04l-5.78,15.48H228.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.12,120.16c0-7.95,5.63-14.24,13.97-14.24c7.76,0,13.91,5.69,13.91,14.24c0,8.61-6.15,14.3-13.91,14.3 C183.75,134.46,178.12,128.19,178.12,120.16z M203.64,120.16c0-7.16-5.17-12.04-11.55-12.04c-6.95,0-11.61,5.42-11.61,12.04 c0,6.68,4.66,12.09,11.61,12.09C198.47,132.25,203.64,127.34,203.64,120.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.78,134.46c-7.55,0-13.85-4.95-13.85-14.11c0-7.99,4.91-14.4,13.85-14.4c3.87,0,7.82,1.57,10.84,5.34 l-1.72,1.41c-2.44-3.02-5.71-4.55-9.11-4.55c-7.3,0-11.49,5.22-11.49,12.19c0,7.49,5.03,11.9,11.49,11.9 c4.08,0,6.98-1.92,9.11-4.51l1.72,1.41C169.16,132.23,165.72,134.46,160.78,134.46L160.78,134.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,130.16l0.9-2.42c1.82,2.44,4.83,4.53,8.91,4.53c3.85,0,6.7-1.99,6.7-5.11c0-3.91-3.15-4.88-7.08-6.41 c-3.93-1.53-8.32-3.08-8.32-7.74c0-4.04,3.66-7.1,8.34-7.1c2.9,0,5.96,1.08,8.57,3.13l-0.86,2.3c-2.19-1.93-5-3.24-7.74-3.24 c-2.94,0-5.88,1.63-5.9,4.78c-0.02,3.39,3.08,4.31,6.68,5.75c4.62,1.84,8.69,3.12,8.69,8.3c0,4.62-4.04,7.53-9.08,7.53 C85.93,134.46,82.33,133.14,79.6,130.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.47,108.54h-8.81v-2.13h19.97v2.13h-8.94l0,25.44h-2.22L114.47,108.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.31,106.41l17.64,0v2.13l-15.41,0l0,10.55l12.95,0v2.13l-12.95,0l0,10.63h15.4v2.13H54.31L54.31,106.41z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.73,106.41l-9.56,27.57H34.7l-7.74-24.26h-0.04l-7.64,24.26H16.8l-9.72-27.57H9.6l8.4,23.87h0.08 l7.5-23.87h2.7l7.62,23.95h0.08l8.22-23.95H46.73z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.65,28.03l18.6,49.86l-31.26-15.9L258.65,28.03 M258.65,7.27l-21.73,58.25l53.63,27.27L258.65,7.27 L258.65,7.27z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.111ac1379979ee2b3a432d96b093e8b7.svg";
export { ForwardRef as ReactComponent };